import React, { useEffect } from "react";
import { Form, Input, InputNumber, Upload, Button, Row, Col, message, Modal } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { updateVehiclesType } from "../../../api/vehicles-type.service";
import { updateTourPackage } from "../../../api/tour-package.service";
import config from '../../../config';

const EditTourPackageModal = ({ vehicleData, onClose, fetchVehicles, isModalOpen, setIsModalOpen, handleOk, handleCancel, isViewOnly = false }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (vehicleData) {
            form.setFieldsValue({
                ...vehicleData,
                picture: vehicleData.picture
                    ? [
                        {
                            uid: "-1",
                            name: vehicleData.picture.split("\\").pop(),
                            status: "done",
                            url: config.API_URL + '/' + vehicleData.picture,
                        },
                    ]
                    : [],
            });
        }
    }, [vehicleData, form]);

    const onFinish = async (values) => {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
            if (key === "picture" && values.picture && values.picture.length > 0) {
                if (values.picture[0].originFileObj) {
                    formData.append(key, values.picture[0].originFileObj);
                }
            } else {
                formData.append(key, values[key]);
            }
        });

        try {
            await updateTourPackage(vehicleData.id, formData);
            message.success("Package updated successfully!");
            fetchVehicles();
            setIsModalOpen(false);
        } catch (error) {
            message.error(error);
            console.error("Error:", error);
        }
    };

    const beforeUpload = (file) => {
        const isImage = file.type.startsWith("image/");
        if (!isImage) {
            message.error("You can only upload image files!");
        }
        return isImage ? false : Upload.LIST_IGNORE;
    };

    return (
        <Modal className="vt-modal" footer={null} destroyOnClose title={`${isViewOnly ? 'View' : 'Edit'} Tour Package`} open={isModalOpen} onOk={handleOk} onClose={handleCancel} onCancel={handleCancel}>
            <Form disabled={isViewOnly} layout="vertical" form={form} onFinish={onFinish}>
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Tour Package Name" name="name" rules={[{ required: true, message: "Please enter package Name" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Duration" name="description" rules={[{ required: true, message: "Please enter description" }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item label="Supplier Email" name="supplierEmail" rules={[{ required: true, message: "Please enter supplier email" }]}>
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Price (PKR)" name="priceInPKR" rules={[{ required: true, message: "Please enter price" }]}>
                            <InputNumber min={0} style={{ width: "100%" }} />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={16}>

                    <Col span={12}>
                        <Form.Item rules={[{ required: true, message: "Picture is required" }]} label="Tour Picture" name="picture" valuePropName="fileList" getValueFromEvent={(e) => e?.fileList || []}>
                            <Upload beforeUpload={beforeUpload} listType="picture" maxCount={1}>
                                <Button icon={<UploadOutlined />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                    </Col>
                </Row>

                {!isViewOnly && <Form.Item>
                    <Button type="primary" htmlType="submit">Update</Button>
                    <Button style={{ marginLeft: 8 }} onClick={() => {
                        setIsModalOpen(false);
                    }}>Cancel</Button>
                </Form.Item>}
            </Form>
        </Modal>
    );
};

export default EditTourPackageModal;
